module.exports = __webpack_public_path__ + "img/config2.082de602.png";